import { j as a } from "../../../jsx-runtime-Wav_3Wde.js";
import r from "../Loadable.mjs";
import e from "./CapitalOneLogoBHMSvg.mjs";
const s = (o) => /* @__PURE__ */ a.jsx(r, {
  RenderedLogo: e,
  logoProps: {
    secondaryColor: "global.black"
  },
  ...o
});
export {
  s as default
};
